import { DigestRequest } from "../Types/DigestRequest";
import { IDigestApiClient } from "../IDigestApiClient";
import { reject } from "../../../TypingUtils";
import { PicklistResultV2 } from "../../../PicklistApiClient/Types/PicklistResultV2";

export function withCache(client: IDigestApiClient): IDigestApiClient {
    return new DigestApiClientWithCache(client);
}

export class DigestApiClientWithCache implements IDigestApiClient {
    private readonly innerClient: IDigestApiClient;
    private readonly responseCache: Map<string, PicklistResultV2> = new Map<string, PicklistResultV2>();

    public constructor(innerClient: IDigestApiClient) {
        this.innerClient = innerClient;
    }

    public async getDigest(request: DigestRequest): Promise<PicklistResultV2> {
        const requestKey = this.getRequestKey(request);
        const requestsNotExistsInCache = !this.responseCache.has(requestKey);
        if (requestsNotExistsInCache) {
            const notInCacheResponse = await this.innerClient.getDigest(request);
            this.responseCache.set(requestKey, notInCacheResponse);
        }
        return this.responseCache.get(requestKey) ?? reject();
    }

    private getRequestKey(request: DigestRequest) {
        return JSON.stringify(request);
    }
}
